export const FETCH_ALL = 'artful-client/Review/FETCH_ALL';
export const FETCH_ALL_SUCCESS = 'artful-client/Review/FETCH_ALL_SUCCESS';
export const FETCH_ALL_FAILURE = 'artful-client/Review/FETCH_ALL_FAILURE';

export const FETCH_ONE = 'artful-client/Review/FETCH_ONE';
export const FETCH_ONE_SUCCESS = 'artful-client/Review/FETCH_ONE_SUCCESS';
export const FETCH_ONE_FAILURE = 'artful-client/Review/FETCH_ONE_FAILURE';

export const CREATE = 'artful-client/Review/CREATE';
export const CREATE_SUCCESS = 'artful-client/Review/CREATE_SUCCESS';
export const CREATE_FAILURE = 'artful-client/Review/CREATE_FAILURE';

export const UPDATE = 'artful-client/Review/UPDATE';
export const UPDATE_SUCCESS = 'artful-client/Review/UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'artful-client/Review/UPDATE_FAILURE';

export const DELETE = 'artful-client/Review/DELETE';
export const DELETE_SUCCESS = 'artful-client/Review/DELETE_SUCCESS';
export const DELETE_FAILURE = 'artful-client/Review/DELETE_FAILURE';
